import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
    'overflowY': 'scroll'
};
const TerminosYCondicionesComponent = (props) => {


    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const formato = props.formato
    React.useEffect(() => {
        if (props.terminosYCondiciones) {
            setTerminosYCondiciones(props.terminosYCondiciones)
        }
    }, [props.terminosYCondiciones])

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" }}>

                            <div align="justify" style={{ color: "black" }}>
                                <label className="form-label"><b>CONSIDERACIONES PARA LA ACEPTACIÓN DE LA SOLICITUD:</b></label>
                                <br />
                                <ul type="a">
                                    <li>Manifiesto que la empresa a la que represento al firmar yo este documento se
                                        compromete a hacer buen uso de la marca y logotipo del COMERCAM,<b> promocionando
                                            exclusivamente los productos para los que haya sido concedida la Certificación
                                            es decir aquellos que cuentan con Certificado NOM vigente y a mantener la vigencia
                                            de los mismos</b> , esto conforme a lo estipulado en el Contrato que la empresa ha firmado
                                        con el COMERCAM y siguiendo lo establecido en el documento de Uso adecuado del sello
                                        de certificación, marca e imagen corporativa del COMERCAM DC-06, y el  Procedimiento
                                        de Producto Certificado (P-PC), vigentes, aceptando la empresa en caso de no respetar
                                        lo descrito en dichos documentos (hacer mal uso de la marca y logotipo del COMERCAM),
                                        la sanción establecida en el Catálogo de Medidas Correctivas (DC-09), vigente.</li>
                                    <li><b>Bajo protesta de decir verdad, manifiesto que los datos asentados en esta
                                        solicitud son ciertos.</b></li>
                                </ul>

                            </div>

                            <center><strong>¿Desea aceptar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'botonTerminosYCondiciones':
                                        botonAceptarTerminosYCondicionesModal()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>ACEPTAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonTerminosYCondiciones = async () => {
        handleOpenModal({
            title: `Términos y condiciones`,
            body: `EL CLIENTE DECLARA BAJO PROTESTA DE DECIR VERDAD`,
            accion: 'botonTerminosYCondiciones'
        })
    }
    const botonAceptarTerminosYCondiciones = async (target) => {
        if (formato === 'fc_05') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_05', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_05', { terminosYCondiciones: false })
            }
        }
    }
    const botonAceptarTerminosYCondicionesModal = async () => {
        if (formato === 'fc_05') {
            props.history.push('/fc_05', { terminosYCondiciones: true })
        }

        setTerminosYCondiciones(true)
        handleCloseModal()
    }
    return (
        <Fragment>
            <div className='col-md-12 text-center'>
                <input className={`form-check-input me-3 escalar `} type="checkbox"
                    onChange={e => botonAceptarTerminosYCondiciones(e.target)}
                    checked={terminosYCondiciones}
                />Acepto los <a href='#' onClick={e => botonTerminosYCondiciones()}>Términos y condiciones</a>
            </div>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(TerminosYCondicionesComponent)
